var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSortDesc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  d: "M15.38 8.5H8.62L12 5.12l3.38 3.38ZM19 10l-7-7-7 7h14Zm0 4H5l7 7 7-7Z"
})));
export { SvgSortDesc as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjM4IDguNUw4LjYyIDguNUwxMiA1LjEyTDE1LjM4IDguNVpNMTkgMTBMMTIgM0w1IDEwTDE5IDEwWk0xOSAxNEw1IDE0TDEyIDIxTDE5IDE0WiIgZmlsbD0iIzMyMzIzMiIvPgo8L3N2Zz4K";